<template>
    <div class="container" :style="{ left: showMenu ? 0 : '100%' }">
        <div v-if="disable" class="disable_mask"></div>
        <ul class="nav">
            <li @click.stop="changeMenu(0)" :class="{ active: activeIndex == 0 }"><i class="iconfont iconwupinku"></i> <span>素材库</span></li>
            <li @click.stop="changeMenu(1)" :class="{ active: activeIndex == 1 }"><i class="iconfont iconxinxibianji"></i> <span>场景信息</span></li>
            <li @click.stop="changeMenu(2)" :class="{ active: activeIndex == 2 }"><i class="iconfont iconjibencaozuo"></i> <span>模型属性</span></li>
        </ul>
        <!-- 素材库 -->
        <div class="menu_0" v-show="activeIndex == 0">
            <model-library></model-library>
        </div>
         
        <!-- 场景信息 -->
        <div v-show="activeIndex == 1" class="menu_1">
            <div class="info_row">
                <div class="label"><i>*</i> 场景名称</div>
                <div class="input r"><el-input v-model="modelInfo.name" :maxlength="20"></el-input></div>
            </div>
            <div class="info_row">
                <div class="label"><i>*</i> 场景分类</div>
                <div class="select r">
                    <el-select v-model="modelInfo.cate1Id" @change="onCateChange" placeholder="一级分类">
                        <el-option
                            v-for="item in cateList"
                            :key="item.cateId"
                            :label="item.cateName"
                            :value="item.cateId">
                        </el-option>
                    </el-select>
                    <el-select v-model="modelInfo.cate2Id" placeholder="二级分类">
                        <el-option
                            v-for="item in subCateList"
                            :key="item.cateId"
                            :label="item.cateName"
                            :value="item.cateId">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="info_row" style="align-items: flex-start;">
                <div class="label" style="position: relative; top: 5px;">&nbsp &nbsp &nbsp &nbsp<i>*</i> 封面</div>
                <div class="preview r" @click="changePreview">
                    <img v-if="modelInfo.preview" :src="modelInfo.preview" />
                    <div v-else>
                        <i class="iconfont iconjiahaotianjia"></i>
                        <p>上传封面</p>
                        <p>推荐尺寸: 760 * 570</p>
                        <p>格式: jpg、png 大小：1M以内</p>
                    </div>
                </div>
            </div>
            <div class="info_row">
                <div class="label">&nbsp &nbsp &nbsp &nbsp &nbsp &nbsp &nbsp &nbsp &nbsp</div>
                <div class="screen r" @click.stop="screenShot"> 
                    <i class="iconfont iconxiangji"></i> <span>屏幕快照</span> 
                </div>
            </div>
            <button hidden id="chooseAvatar"></button>
        </div>

        <div v-show="activeIndex == 2" class="menu_2">
            <!-- 模型信息设置 -->
            <information v-show="showInformation"></information>
        </div>

        <div class="toggle" @click="toggleScreen">
            <i class="iconfont iconshangyibu" v-if="!showMenu"></i>
            <i class="iconfont iconxiayibu" v-else></i>
        </div>
    </div>
</template>

<script>
import Information from './Information.vue'
import ModelLibrary from './ModelLibrary.vue'
import BusEvent from '@/busEvent'

export default{

    components:{
        Information,
        ModelLibrary
    },

    props: {
        sceneData: {
            default: {}
        }
    },

    data(){
        return {
            disable: false,
            hideCursor: false,
            activeIndex: 0,
            cateList: [],
            subCateList: [],
            modelInfo: {
                name: '',
                cate1Id: '',
                cate2Id: '',
                preview: ''
            },
            showMenu: true,
            showInformation: false
        }
    },

    watch: {
        sceneData( val ){
            var { name, cate1Id, cate2Id, preview } = val
            this.modelInfo = {
                name,
                cate1Id,
                cate2Id,
                preview
            }
            this.onCateChange( cate1Id )
        }
    },

    computed: {
        viewer(){
            return window.viewer
        }
    },

    mounted(){
        this.init()
        this.$bus.$on( BusEvent.MenuDisbaledChange, status => this.disable = status )
        this.$bus.$on( BusEvent.SelectedChange, () => {
            if( this.viewer.selectedObject.length == 1 ){
                this.activeIndex = 2
                this.showInformation = true
            }else if( this.activeIndex == 2 ){
                this.activeIndex = 0
                this.showInformation = false
            }
        })
    },

    methods: {

        init(){
            this.axios.post('/api-application/fullSceneEditor/unauth/worksCateList').then(res => {
                this.cateList = res.datas || []
                if( this.modelInfo.cate1Id ) this.onCateChange( this.modelInfo.cate1Id )
            })
        },

        /**
         * 切换主菜单
         */
        changeMenu( index ){
            this.activeIndex = index
        },

        /**
         * 更换预览图
         */
        changePreview(){
            this.$util.uploadOBS( 'image' ).then(res => {
                if( res.url ) this.modelInfo.preview = res.url
            })
        },

        /**
         * 切换一级分类
         */
        onCateChange( cateId ){
            let cate = this.cateList.find( item => item.cateId == cateId )
            if( cate && Array.isArray( cate.worksLabelObjectVOList ) && cate.worksLabelObjectVOList.length > 0 ){
                this.subCateList = cate.worksLabelObjectVOList
                this.modelInfo.cate2Id = cate.worksLabelObjectVOList[0].cateId
            }else{
                this.modelInfo.cate2Id = ''
                this.subCateList = []
            }
            
        },

        /**
         * 截屏并上传
         */
        screenShot(){
            this.$bus.$emit( BusEvent.ToolChange )
            let loading = this.$loading({})
            try {
                var imgStr = this.viewer.screenShot()
                this.axios.post('/api-transaction/laozi/v3/transaction/uploadImg', { imgStr }).then( res => {
                    loading.close()
                    this.modelInfo.preview = res.datas.url
                }) 
            } catch (error) {
                loading.close()
            }
        },

        toggleScreen(){
            this.viewer.map.scene.screenSpaceCameraController.maximumZoomDistance =  !this.showMenu ? 16000000 : 21000000
            this.showMenu = !this.showMenu
            this.$emit('toggleScreen', this.showMenu)
            setTimeout(() => {
                viewer.gisManager.resetCamera()
            }, 100)
        }
    }
}

</script>

<style lang="scss" scoped>
.container{
    height: 100%; position: relative;
    .disable_mask{ width: 100%; height: 100%; background-color: rgba(255,255,255,0.7);position: absolute; z-index: 1;top: 0;left: 0; cursor: no-drop; }
    .toggle{ 
        width: 24px; height: 48px; background-image: url('~@/assets/img/toggle.png'); background-size: contain; position: absolute; top: calc(50% - 12px); left: -24px; text-align: center; line-height: 48px; cursor: pointer;
        .iconfont{ font-size: 20px; color: #5D6B7F;  }
        &:hover{ 
            .iconfont{ font-size: 20px; color: #FFF;  }
        }
    }
}
.nav{
    display: flex; width: 100%; height: 48px; align-items: center; justify-content: space-around;
    li{ 
        span{ color: #3B3B3B; margin-top: 5px; font-size: 14px; }
        .iconfont{ color: #5D6B7F; font-size: 20px; position: relative; left: -5px; top: 2px; }
        width: 50%; height: 100%; border-left: 1px solid rgba(0,0,0,0.1); display: flex; align-items: center; justify-content: center; cursor: pointer;position: relative;border-bottom: 1px solid  rgba(0,0,0,0.1);
    }
    .active{
        span{ color: #1458EA; }
        .iconfont{ color: #1458EA; } 
    }
}
.menu_0{ width: 100%; height: calc(100% - 48px); }
.menu_1{
    background-color: #F2F4F6; height: calc(100% - 65px);padding-top: 10px;
    .info_row{
        display: flex; justify-content: center; align-items: center; padding: 10px 0;
        .label{ 
            margin-right: 10px;  font-size: 14px; color: #999; 
            i{color: #F00; font-style: normal; font-size: 16px; position: relative; top: 5px;}
        }
        .r{ width: 70%; }
        .select{ 
            display: flex; 
            /deep/.el-select:nth-child(1){ 
                margin-right: 10px;
            }
        }
        .preview{
            background-color: #fff; padding: 10px; width: calc(70% - 20px); height: 150px; padding: 10px; border-radius: 5px; cursor: pointer;
            >img{ width: 100%; height: 100%; }
            >div{ 
                width: 100%; height: 100%; border-radius: 5px; border: 1px dotted #ccc; display: flex; flex-direction: column; justify-content: center; align-items: center;
                p{ color: #999; font-size: 14px; line-height: 22px; } 
                .iconfont{ color: #999; font-size: 22px; margin-bottom: 20px; }
            }
        }
        /deep/ .el-input{
            .el-input__inner{ background-color: #fff; border: none; }
        }

        .screen{ 
            display: flex; justify-content: center; align-items: center; padding: 10px 0; width: 70%; background-color: #fff; cursor: pointer; border-radius: 5px;
            span{margin-left: 10px; color: #1458EA; font-size: 14px;}
            .iconfont{color: #1458EA; font-size: 18px;}
        }
    }
}

.menu_2{
    background-color: #F2F4F6; height: calc(100% - 65px);padding-top: 10px;
}
</style>
